import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ListingTypeForm from '../../../components/forms/ListingTypeForm';
import { useListingTypeById, useUpdateListingType } from '../../../hooks/useListingTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ListingTypeDTO } from '../../../services/apiClient';

const ListingTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: entityData, isLoading } = useListingTypeById(id);
  const updateMutation = useUpdateListingType();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Listing Types', href: '/admin/listingtypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/listingtypes');
    } catch (error) {
      console.error('Error updating ListingType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/listingtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ListingType.Edit"
    >
      {entityData ? (
        <ListingTypeForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/listingtypes')}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default ListingTypeEdit;
